"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MicroFrontendEvent {
    static registerEvent(topic, action) {
        window.addEventListener(topic, (e) => action(e));
    }
    static dispatchEvent(topic, detail) {
        window.dispatchEvent(new CustomEvent(topic, { detail }));
    }
}
exports.default = MicroFrontendEvent;
